// extracted by mini-css-extract-plugin
export default {"root":"xSv6okUHH1MofhAQQjWN"};